import { HtmlHTMLAttributes, useEffect, useState } from "react";
import styled from "styled-components";
import TabComponent from "../components/home/tabComponent";
import CustomButton from "../components/common/customButton";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Cookies } from "react-cookie";
import { Toast } from "../components/common/toastMessegeComponent";
import { Image } from "../components/common/image";
const cookies = new Cookies();

const ContainerLogin = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  height: 100vh;
`;

const ContainerSub = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;

  /* 모바일*/
  @media (max-width: 767px) {
    padding: 30px;
    font-size: 16px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    padding: 20px 100px;
    font-size: 18px;
  }

  /* PC */
  @media (min-width: 1200px) {
    padding: 0px 700px;
    font-size: 20px;
  }
`;

const LogoTextBox = styled.div`
  width: 100%;
  /* 모바일*/
  @media (max-width: 767px) {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    margin-top: 50px;
    margin-bottom: 20px;
  }

  /* PC */
  @media (min-width: 1200px) {
    margin-top: 80px;
    margin-bottom: 30px;
  }
`;

const LoginLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* 모바일*/
  @media (max-width: 767px) {
    width: 100%;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    width: 100%;
  }

  /* PC */
  @media (min-width: 1200px) {
    width: 50%;
  }
`;

const LogoText = styled.div`
  width: 100%;
  height: 6vw;
  display: flex;
  justify-content: start;
  align-items: center;
  text-align: center;
  font-weight: 500;
  font-size: 2.2vw;
  color: #0f0f0f;
  letter-spacing: 0.4vw;

  @media screen and (min-width: 1024px) {
    font-size: 24px;
    letter-spacing: 2px;
    height: 40px;
  }
`;
const LogoText2 = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  text-align: center;
  color: #0f0f0f;

  /* 모바일*/
  @media (max-width: 767px) {
    font-weight: 900;
    font-size: 7vw;
    letter-spacing: 4px;
    margin-bottom: 4px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    font-weight: 900;
    font-size: 7vw;
    letter-spacing: 6px;
    margin-bottom: 6px;
  }

  /* PC */
  @media (min-width: 1200px) {
    font-weight: 900;
    font-size: 80px;
    letter-spacing: 10px;
    margin-bottom: 10px;
  }
`;

const OutlineInputbox = styled.div<{
  $outLine?: string;
}>`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: white;
  outline: ${(props) => props.$outLine};

  /* 모바일*/
  @media (max-width: 767px) {
    height: 42px;
    border-radius: 4px;
    margin-bottom: 20px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    height: 60px;
    border-radius: 6px;
    margin-bottom: 30px;
  }

  /* PC */
  @media (min-width: 1200px) {
    height: 80px;
    border-radius: 8px;
    margin-bottom: 30px;
  }
`;

const Inputbox = styled.input`
  background-color: transparent;
  margin-left: 2vw;
  outline: none;
  border: none;

  /* 모바일*/
  @media (max-width: 767px) {
    font-size: 16px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    font-size: 24px;
  }

  /* PC */
  @media (min-width: 1200px) {
    font-size: 30px;
  }
`;

const BottomArea = styled.div`
  width: 100%;
  display: flex;
  /* 모바일*/
  @media (max-width: 767px) {
    height: 30px;
    margin-bottom: 10px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    height: 30px;
    margin-bottom: 20px;
  }

  /* PC */
  @media (min-width: 1200px) {
    height: 40px;
    margin-bottom: 20px;
  }
`;

const RememberAccountBox = styled.div<{
  // onClick?: MouseEventHandler<HTMLDivElement>;
}>`
  display: flex;
  height: 20px;
  justify-content: center;
  align-items: center;
`;

const TextLine = styled.p`
  display: flex;
  align-items: center;
  font-weight: 300;
  border-bottom: 1px solid black;
  height: 20px;
  /* 모바일*/
  @media (max-width: 767px) {
    font-size: 16px;
    margin-left: 4px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    font-size: 24px;
    margin-left: 8px;
  }

  /* PC */
  @media (min-width: 1200px) {
    font-size: 26px;
    height: 26px;
    margin-left: 10px;
  }
`;

const ButtonArea = styled.div`
  width: 100%;
  /* 모바일*/
  @media (max-width: 767px) {
    height: 40px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    height: 50px;
  }

  /* PC */
  @media (min-width: 1200px) {
    height: 80px;
  }
`;

export default function Login() {
  const navigate = useNavigate();
  const rememberAccountString = localStorage.getItem("rememberAccount");

  const rememberAccount =
    rememberAccountString !== null ? JSON.parse(rememberAccountString) : false;

  const loginUserString = localStorage.getItem("loginUser");

  const loginUser = loginUserString && JSON.parse(loginUserString);

  const tonginOrange = "2px solid #FF7F3B";
  const tonginDisable = "1px solid #E7E7E7";
  const [outLineId, setoutLineId] = useState(tonginDisable);
  const [outLinePswd, setoutLinePswd] = useState(tonginDisable);
  const [bgColor, setBgColor] = useState("#B9C1C9");
  const [desabled, setDesabled] = useState(true);
  const [fetchStatus, setFetchStatus] = useState(false); // toast messege
  const [status, setStatus] = useState(""); // toast messege
  const [id, setId] = useState("");
  const [pswd, setPswd] = useState("");
  const [loginData, setLoginData] = useState({ id, pswd });
  const [isChecked, setIsChekced] = useState<boolean>(rememberAccount);

  useEffect(() => {
    if (rememberAccount) {
      const accountString = localStorage.getItem("account");
      const account = accountString && JSON.parse(accountString);
      setId(account.id);
      setPswd(account.pswd);
    }
  }, []);

  const onFocusHandle = (e: any) => {
    if (e.target.id === "Id") setoutLineId(tonginOrange);
    else if (e.target.id === "Pw") setoutLinePswd(tonginOrange);
  };

  const onblurHandle = (e: any) => {
    setoutLineId(tonginDisable);
    setoutLinePswd(tonginDisable);
  };

  const onDisabled = (desabled: any) => {
    if (desabled) {
      setBgColor("#B9C1C9");
      setDesabled(true);
    }
    if (desabled === false) {
      setBgColor("#FF7F3B");
      setDesabled(false);
    }
  };

  const onInputId = (e: any) => {
    setId(e.target.value);
  };
  const onInputPswd = (e: any) => {
    setPswd(e.target.value);
  };

  useEffect(() => {
    setLoginData((prev: any) => {
      const updatedData = { ...prev };
      updatedData.id = id;
      updatedData.pswd = pswd;
      return updatedData;
    });
    if (id.length > 1 && pswd.length > 1) {
      onDisabled(false);
    } else {
      onDisabled(true);
    }
  }, [id, pswd]);
  const onLogin = async (e: React.KeyboardEvent) => {
    if (desabled) {
      return;
    }
    const requestParam = {
      header: {},
      body: {
        userId: id,
        password: pswd,
      },
    };
    try {
      const response: any = await axios.post(
        "https://homenmove.net/v1/api/auth/login",
        requestParam
      );

      localStorage.setItem(
        "accessToken",
        response.data.data.tokens.accessToken
      );

      // 로그인 유저 타입 flag

      let isCompanyContractTeam = false;
      let isPlumberTeam = false;
      let isMattressTeam = false;
      let userType = "normal";

      // 기업이전팀 소속코드
      const companyContractBranch = [
        "BE0874",
        "BE0860",
        "BE0783",
        "BE0687",
        "BE0507",
        "BE0834",
        "BE0627", // h&c
        "BE0216", // 본사
        "BE0811", // 주미선 부장
        "BE0885", // 김동희 차장
      ];

      // 매트리스케어팀 소속 코드
      const mattressTeam = ["BE0995"];

      // 청년배관팀 소속 코드
      const plumberTeam = ["BE0996"];

      const userBranchCode = response.data.data.user.branch.branchCode;

      if (companyContractBranch.includes(userBranchCode)) {
        isCompanyContractTeam = true;
      } else {
        isCompanyContractTeam = false;
      }

      if (mattressTeam.includes(userBranchCode)) {
        isMattressTeam = true;
        userType = "mattress";
      } else {
        isMattressTeam = false;
      }

      if (plumberTeam.includes(userBranchCode)) {
        isPlumberTeam = true;
        userType = "plumber";
      } else {
        isPlumberTeam = false;
      }

      const loginUser = {
        ...response.data.data.user,
        isCompanyContractTeam,
        isMattressTeam,
        isPlumberTeam,
        userType,
      };

      localStorage.setItem("loginUser", JSON.stringify(loginUser));
      localStorage.setItem("rememberAccount", JSON.stringify(isChecked));
      if (isChecked) {
        localStorage.setItem("account", JSON.stringify(loginData));
      } else {
        localStorage.setItem("account", "");
      }

      cookies.set("refreshToken", response.data.data.tokens.refreshToken);
      navigate("/");
    } catch (error) {
      setFetchStatus(true);
      setStatus("FAIL");
      // alert(error);
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      onLogin(e);
    }
  };

  return (
    <>
      <ContainerLogin>
        {fetchStatus && (
          <Toast
            status={status}
            fetchStatus={fetchStatus}
            setFetchStatus={setFetchStatus}
            text={"아이디 비밀번호를 다시 확인해주세요."}
          />
        )}
        <LoginLogo>
          <Image
            src="icon/login_background.png"
            alt="로고 이미지"
            width={"100%"}
            height={"100%"}
          />
        </LoginLogo>
        <ContainerSub>
          <LogoTextBox>
            <LogoText>마음까지 통하는 사람들</LogoText>
            <LogoText2>통인익스프레스</LogoText2>
            <LogoText2>전자계약시스템</LogoText2>
          </LogoTextBox>
          <OutlineInputbox $outLine={outLineId}>
            <Inputbox
              onInput={onInputId}
              id={"Id"}
              onFocus={onFocusHandle}
              onBlur={onblurHandle}
              value={id}
              placeholder="아이디를 입력해 주세요"
            ></Inputbox>
          </OutlineInputbox>
          <OutlineInputbox $outLine={outLinePswd}>
            <Inputbox
              id={"Pw"}
              onInput={onInputPswd}
              onFocus={onFocusHandle}
              onBlur={onblurHandle}
              type="password"
              value={pswd}
              placeholder="비밀번호를 입력해 주세요"
              onKeyPress={handleKeyDown}
            ></Inputbox>
          </OutlineInputbox>
          <BottomArea>
            <RememberAccountBox
              onClick={() => {
                setIsChekced(!isChecked);
              }}
            >
              <Image
                src={`icon/${isChecked ? "checked" : "unchecked"}.png`}
                alt="checkbox"
                width={"20px"}
                height={"20px"}
              />
              <TextLine>아이디/비밀번호 기억하기</TextLine>
            </RememberAccountBox>
          </BottomArea>
          <ButtonArea>
            <CustomButton
              onClick={(e: React.KeyboardEvent) => onLogin(e)}
              width={"100%"}
              height={"100%"}
              text={`로그인`}
              disabled={desabled}
              $bgColor={bgColor}
            ></CustomButton>
          </ButtonArea>
        </ContainerSub>
      </ContainerLogin>
    </>
  );
}
